import FilterSelector from "./components/filter-selector";
import CustomSearch from "./components/custom-search";
import "./components/fancy-dots-optimized";
import FancyDots from "./components/fancy-dots";

customElements.define("filter-selector", FilterSelector);
customElements.define("custom-search", CustomSearch);
//customElements.define("fancy-dots", FancyDots);
